/**
 * Taal: Nederlands (Dutch).
 */
export default {
    time: {
        openingHoursTitle: "Openingstijden",
        at: "om",
	to: "tot",
        opensToday: "Opent vandaag",
        opens: "Opent",
        open24_7: "24/7 geopend",
        closed: "Gesloten",
        openUntil: "Geopend tot",
        daily: "Dagelijks geopend van",
        month: [
            'Januari', 'Februari', 'Maart', 'April', 'Mei', 'Juni',
            'Juli', 'Augustus', 'September', 'Oktober', 'November', 'December'
        ],
        monthAbbr: [
            'Jan', 'Feb', 'Mrt', 'Apr', 'Mei', 'Jun',
            'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Dec'
        ],
        dayOfWeek: [
            'Maandag', 'Dinsdag', 'Woensdag', 'Donderdag', 'Vrijdag', 'Zaterdag','Zondag', 
        ],
        dayOfWeekAbbr: [
            'Ma', 'Di', 'Wo', 'Do', 'Vr', 'Za','Zo', 
        ],
        temporarilyClosed: "Tijdelijk gesloten",
        opened: "",
        today: ""
    },
    search: {
        placeholder: "Straat, stad of postcode",
        submitLabel: "Zoeken",
        clearLabel: "Zoekopdracht wissen",
        yourLocation: "Je locatie",
    },
    filtering: {
        servicesTitle: "Diensten",
        services: {
            WF: 'Wireless Hotspot',
            CD: 'Mobiele Betaling',
            DT: 'Drive-Thru',
            DR: 'Digitale Beloningen',
            hrs24: '24 uur per dag geopend',
            WA: 'Voedsel opwarmen',
            LB: 'LaBoulange',
            XO: 'Mobiel Bestellen en Betalen',
            VS: 'Verismo',
            NB: 'Nitro Koud Brouwsel',
            CL: 'Starbucks Reserve-Clover Brewed',
        }
    },
    stores: {
        cta: {
            call: "Bellen",
            directions: "Routebeschrijving",
            website: "Website",
            'club details': 'Club details',
            'view tariffs': 'Join now',
            'View Map': "Kaart bekijken",
            'View List': "Lijst bekijken"
        },
        messages: {
            initialHeader: "Begin met het zoeken van een plaats om nabijgelegen clubs weer te geven",
            emptyHeader: "Geen club gevonden",
            initialBody: "of klik op de kaart om een club te selecteren",
            emptyBody: "Zoek a.u.b. ergens anders naar een plaats of schakel de filters uit"
        }
    },
    directions: {
        avoidOptions: {
            highways: 'Snelwegen',
            tolls: 'Tolwegen',
            ferries: 'Veerponten'
        },
        unitOptions: {
            METRIC: 'km',
            IMPERIAL: 'mijl'
        },
        options: "Routeopties",
        avoid: "Vermijd",
        units: "Afstandseenheden",
        messages: {
            initialBody: "Zoek een vertrek- en bestemmingspunt om beschikbare routes en reistijd te zien.",
            error: "Sorry, we konden de routebeschrijving niet berekenen",
            from: "van",
            to: "naar",
            forTravelMode: "voor de reismodus",
            via: "via",
            details: "Details",
            withoutTraffic: "zonder verkeer",
            openGoogleMaps: "openen in Google Maps"
        }
    },
    errors: {
        loadingLibrary: "Laden van het {library} script is mislukt",
        geolocationFailed: "Geolocatie van gebruiker mislukt",
        apiErrors:{
            "401": "Niet geautoriseerd",
            "403": "Verboden",
            "429": "Te veel verzoeken",
            "500": "Interne serverfout",
            other: "Er is een onverwachte serverfout opgetreden"
        }
    },
};
